import * as yup from 'yup';
import { dateStringToDate } from '../utils/date';
const mmddyyyyRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{4}$/;
export const getActivationValidationSchema = (requireWeekStartsOn) => yup
    .object()
    .shape({
    lossDays: yup
        .number()
        .required('This is required')
        .min(0, 'Must be at least 0')
        .max(7, 'Must be at most 7'),
    mainteanceDays: yup
        .number()
        .required('This is required')
        .min(0, 'Must be at least 0')
        .max(7, 'Must be at most 7'),
    rewardDays: yup
        .number()
        .required('This is required')
        .min(0, 'Must be at least 0')
        .max(7, 'Must be at most 7'),
    // dummy field to hold our sum-error
    totalDays: yup.string().notRequired(),
    weekStartsOn: requireWeekStartsOn
        ? yup
            .mixed()
            .oneOf([0, 1], 'Choose Sunday or Monday')
            .required('Week start is required')
        : yup.mixed().notRequired(),
    startDate: yup
        .string()
        .required('Starting date is required')
        .matches(mmddyyyyRegex, 'Date must be in MM-DD-YYYY format')
        .test('is-valid-start', 'Start date is not a valid calendar date', val => {
        const d = dateStringToDate(val || '');
        if (!d || d.toString() === 'Invalid Date') {
            return false;
        }
        const [mm, dd, yyyy] = (val || '').split('-').map(Number);
        return (d.getFullYear() === yyyy &&
            d.getMonth() === mm - 1 &&
            d.getDate() === dd);
    }),
    endDate: yup
        .string()
        .required('End date is required')
        .matches(mmddyyyyRegex, 'Date must be in MM-DD-YYYY format')
        .test('is-valid-end', 'End date is not a valid calendar date', val => {
        const d = dateStringToDate(val || '');
        if (!d || d.toString() === 'Invalid Date') {
            return false;
        }
        const [mm, dd, yyyy] = (val || '').split('-').map(Number);
        return (d.getFullYear() === yyyy &&
            d.getMonth() === mm - 1 &&
            d.getDate() === dd);
    })
        .test('is-after-start', 'End date must be after start date', function (endVal) {
        const { startDate } = this.parent;
        if (!endVal || !startDate) {
            // validation for previous fields will handle this
            return true;
        }
        const start = dateStringToDate(startDate);
        const end = dateStringToDate(endVal);
        if (!start || !end) {
            return true;
        }
        return end > start;
    }),
})
    .test({
    name: 'sum-is-7',
    message: 'Loss + Maintenance + Reward days must add up to 7',
    test(values) {
        const { lossDays = 0, mainteanceDays = 0, rewardDays = 0 } = values || {};
        if (lossDays + mainteanceDays + rewardDays === 7) {
            return true;
        }
        // force the error onto our dummy key
        return this.createError({ path: 'totalDays' });
    },
});
/** @deprecated Prefer getActivationValidationSchema(requireWeekStartsOn) */
export const activationValidationSchema = getActivationValidationSchema(false);
